import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";


const MARKET_PLACE_URL = process.env.NEXT_PUBLIC_MARKETPLACE_URL;


export interface MakeSearch {
  id: number; 
  name: string; 
}

export interface ModelSearch {
  id: number; 
  name: string;
}


export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price:string) {
  const amount = parseFloat(price);
  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);  
  return formatted;
}

export function checkSearchModels(newArr: any, value: number) {
  let ret_val =  false;
  const res= newArr?.map((model) => {

    let model_id = model[0]?.id  
    if (model_id == value) {     
      ret_val =  true;      
    }      

  });

  return ret_val;
 
}

export function removeSearchMakes(currentArr: any, value: number) {
  let newArr = [];
  
  interface MakesItems extends Array<MakeSearch>{}
  currentArr?.map((make, index) => {
    let make_id = make[0]?.id
   
    if (make_id != value) {
      var result: MakesItems[] = [
        { id: make_id },     
      ]; 
      newArr.push(result);
    }
  });
  return newArr;
}

export function removeSearchModels(currentArr: any, value: number) {
  let newArr = [];
  interface ModelItems extends Array<ModelSearch>{}
  currentArr?.map((model, index) => {
    let model_id = model[0]?.id
   
    if (model_id != value) {
      var result: ModelItems[] = [
        { id: model_id  },     
      ]; 
    
      newArr.push(result);
    }
  });
  return newArr;
}


export function buildVehicleUrl(vehicle:any) {
  //console.log("VECHILCE : ", vehicle)
  const url = MARKET_PLACE_URL + '/vehiculo/' + vehicle.makes.name + '/' +
    vehicle.models.name + '/' + vehicle.fueltypes.name +
    '-' + vehicle.transmissions.name + '/' +
    vehicle.year + '/' + vehicle.id;

  return formatSeoUrl(url);

}

export function formatSeoUrl(url:string) {


  return url.toString()               // Convert to string
  .normalize('NFD')               // Change diacritics
  //.replace(/[\u0300-\u036f]/g,'') // Remove illegal characters
  .replace(/\s+/g,'-')            // Change whitespace to dashes
  .replace('á','a')    
  .replace('ó','o')         
  .toLowerCase()                  // Change to lowercase
  .replace(/&/g,'-and-')          // Replace ampersand
  //.replace(/[^a-z0-9\-]/g,'')     // Remove anything that is not a letter, number or dash
  //.replace(/-+/g,'-')             // Remove duplicate dashes
  //.replace(/^-*/,'')              // Remove starting dashes
  //.replace(/-*$/,'');             // Remove trailing dashes
}

export function generateAlphanumeric(length: number): string {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
